<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">基本信息</span>
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" style="width: 400px;">
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入角色名称" />
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">权限范围</span>
      </div>
      <el-form :model="secondForm" label-width="100px">
        <!-- <el-form-item label="机构权限" style="width: 500px;">
          <el-input
            v-model="filterText2"
            placeholder="输入关键字进行过滤"
          />
          <el-tree
            ref="tree2"
            class="filter-tree"
            :data="datatree2"
            show-checkbox
            :props="defaultProps"
            default-expand-all
            check-strictly="true"
            :filter-node-method="filterNode2"
          />
        </el-form-item> -->
        <el-form-item label="用户权限" style="width: 500px;">
          <div class="border">
            <el-input
              v-model="filterText"
              placeholder="输入关键字进行过滤"
            />
            <el-tree
              ref="tree"
              class="filter-tree"
              :data="datatree"
              show-checkbox
              :props="defaultProps"
              default-expand-all
              check-strictly="true"
              :filter-node-method="filterNode"
            />
          </div>
        </el-form-item>
        <el-form-item label="电站权限" style="width: 500px;">
          <div class="border">
            <el-input
              v-model="filterText1"
              placeholder="输入关键字进行过滤"
            />
            <el-tree
              ref="tree1"
              class="filter-tree"
              :data="datatree1"
              show-checkbox
              :props="defaultProps"
              default-expand-all
              :filter-node-method="filterNode1"
            />
          </div>
        </el-form-item>
      </el-form>
    </el-card>
    <div class="el-card-never-btn">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit(true)">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Xinzengjuese',
  components: {},
  data() {
    return {
      form: {
        name: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ]
      },
      secondForm: {},
      datatree: [],
      datatree1: [],
      datatree2: [],
      filterText: '',
      filterText1: '',
      filterText2: '',
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      isShow: true,
      ids: [],
      station: [],
      org: [],
      org1: [],
      organ: [],
      org2: []
    }
  },
  computed: {
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    filterText1(val) {
      this.$refs.tree1.filter(val)
    },
    filterText2(val) {
      this.$refs.tree2.filter(val)
    }
  },
  mounted() {
    this.getOrgTree()
    this.getStationTree()
    this.getOrganTree()
  },
  methods: {

    async onSubmit(flag) {
      try {
        // 必填校验
        await Promise.all([
          this.$refs.form.validate()
        ])
      } catch (error) {
        return
      }
      if (!flag) {
        this.$router.go(-1)
        return
      }
      this.ids = []
      this.org = []// 用户权限

      this.station = []
      this.org1 = []// 电站权限

      this.organ = []
      this.org2 = []// 机构权限

      // const nodes2 = this.$refs.tree2.getCheckedNodes(false, true)
      // console.log('nodes', nodes2)
      // for (let i = 0; i < nodes2.length; i++) {
      //   const node = nodes2[i]
      //   if (!node.noData) {
      //     this.organ.push(node.id)
      //     this.org2.push(node.id)
      //   }
      // }

      const nodes = this.$refs.tree.getCheckedNodes(false, true)
      console.log('nodes', nodes)
      for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i]
        if (!node.noData) {
          this.ids.push(node.id)
          this.org.push(node.id)
        }
      }

      const items = this.$refs.tree1.getCheckedNodes(false, true)
      console.log('item', items)
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        if (item.attrs.type === 'org') {
          this.org1.push(item.id)
        } else if (item.attrs.type === 'station') {
          this.station.push(item.id)
        }
      }

      for (let i = 0; i < this.org.length; i++) {
        for (let j = 0; j < this.org2.length; j++) {
          if (this.org[i] === this.org2[j]) {
            this.org.splice(i, 1) // 利用splice函数删除元素，从第i个位置，截取长度为1的元素
          }
        }
      }
      for (let i = 0; i < this.org2.length; i++) {
        this.org.push(this.org2[i])
      }
      console.log(this.org, this.org1, this.org2, this.organ)

      // let data = {
      //   name: this.form.name
      // }

      // console.log("ids", this.ids)
      // console.log("station", this.station)
      // console.log("org", this.org)
      // this.$store.dispatch("form/handle", {
      //   url: "/auth/role",
      //   data: data,
      //   method: "put",
      //   callback: resp => {
      //     console.log(resp)
      const data = {
        // roleId: resp.id,
        name: this.form.name,
        data: {
          'org': this.org,
          'org.user': this.ids,
          'org.station': this.station
        }
      }
      this.$store.dispatch('form/handle', {
        url: '/auth',
        data: data,
        method: 'put',
        callback: resp => {
          console.log(resp)
          this.$router.go(-1)
        }
      })
      //   }
      // });
    },
    cancel() {
      this.$router.go(-1)
    },

    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },

    filterNode1(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    filterNode2(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    getOrganTree() {
      const data = {
        bizType: 'org'
      }
      this.$store.dispatch('form/handle', {
        url: '/auth/findMy',
        data: data,
        method: 'get',
        callback: resp => {
          this.datatree2 = resp
        }
      })
    },

    getOrgTree() {
      const data = {
        bizType: 'org.user'
      }
      this.$store.dispatch('form/handle', {
        url: '/auth/findMy',
        data: data,
        method: 'get',
        callback: resp => {
          this.datatree = resp
        }
      })
    },

    getStationTree() {
      const data = {
        bizType: 'org.station'
      }
      this.$store.dispatch('form/handle', {
        url: '/auth/findMy',
        data: data,
        method: 'get',
        callback: resp => {
          this.datatree1 = resp
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
  .border {
    border: 1px solid #EEEEEE;
    padding: 20px;
    height: 300px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/userManagement/addrole.vue